export default __webpack_public_path__ + "static/media/George-Fischer 1.6a538199.png";